<template>
  <sec-hero tinted :eyebrow="hero.eyebrow" :title="hero.title" :lede="hero.lede">
    <p class="m500 home-hero__agents" data-reveal>{{ hero.agents }}</p>
    <sec-actions :actions="hero.actions" />
    <template #aside>
      <sec-terminal
        :label="hero.terminal.label"
        :title="hero.terminal.title"
        :status="hero.terminal.status"
        :lines="hero.terminal.lines"
        :summary="hero.terminal.summary"
      />
    </template>
    <template #footer>
      <sec-trust-row :items="hero.trust.items" />
    </template>
  </sec-hero>
</template>

<script setup>
import SecHero from '@/components/security/ui/SecHero.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import SecTerminal from '@/components/security/ui/SecTerminal.vue';
import SecTrustRow from '@/components/security/ui/SecTrustRow.vue';
import { HOME } from '@/content/security/home';

const hero = HOME.hero;
</script>

<style scoped>
.home-hero__agents {
  font-size: 1rem;
  line-height: 160%;
  color: var(--sec-ink-2);
  max-width: 60ch;
  padding-left: var(--sec-s2);
  border-left: 2px solid var(--sec-accent);
}
</style>
